import angular from 'angular';
import uiCianTabsAdapter from '../../adapters/ui.bootstrap.tabs/tabs.module';
import './styles.styl';

export default angular
	.module('ui.cian.tabs', [uiCianTabsAdapter])
	.name;
